export const FOCUSABLE_ELEMENTS_SELECTOR =
  '[href], button, input, textarea, select, details, [contenteditable="true"], [tabindex]';
